import { render } from "./IndexInventoriesPage.vue?vue&type=template&id=775fec0c"
import script from "./IndexInventoriesPage.vue?vue&type=script&lang=js"
export * from "./IndexInventoriesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__